import { namespaceGeneratedIdentifiers } from './namespace-generated-identifiers.js'
import { namespaceModuleSpecifiers } from './namespace-module-specifiers.js'

export function namespaceGeneratedContent(
  content: string,
  namespace: string,
  filePath: string
): string {
  return namespaceModuleSpecifiers(
    namespaceGeneratedIdentifiers(content, namespace, filePath),
    namespace
  )
}
